import { Line } from '@ant-design/charts';
import { useGet } from '@threatadvisor/react-utils';
import { Typography } from 'antd';
import React, { ReactElement, useId } from 'react';

export type DetectionCaseVolumeByDayProps = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
  securityEventApi: string;
};

export default function DetectionCaseVolumeByDay(
  props: DetectionCaseVolumeByDayProps
): ReactElement {
  const { clientUid, reportStart, reportEnd, securityEventApi } = props;

  const { data: detectionCaseVol } = useGet<{ date: number; value: number; category: string }[]>(
    `${securityEventApi}/report/statusreport/detectionvolume`,
    {
      query: {
        clientUid: clientUid,
        startDate: reportStart,
        endDate: reportEnd
      },
      select: (result: unknown) => {
        let results;

        if (result && Array.isArray(result)) {
          if (
            (result ?? []).reduce(
              (accum, curr) => accum + curr.created + curr.escalated + curr.closed,
              0
            ) == 0
          )
            return [];
          results = [
            ...result.map(r => ({
              date: r.series.getTime(),
              value: r.created,
              category: 'Created'
            })),
            ...result.map(r => ({
              date: r.series.getTime(),
              value: r.escalated,
              category: 'Escalated'
            })),
            ...result.map(r => ({ date: r.series.getTime(), value: r.closed, category: 'Closed' }))
          ];
        }
        return results ?? [];
      }
    }
  );

  const myId = useId();

  if (!window['chartRenders']) window['chartRenders'] = {};
  window['chartRenders'][myId] = 'Rendering';

  const config = {
    data: detectionCaseVol,
    xField: 'date',
    yField: 'value',
    // seriesField: 'category',
    scale: {
      x: {
        type: 'time',
        utc: true,
        mask: 'MM/DD/YYYY'
      }
    },
    theme: {
      type: 'threatadvisor'
    },
    colorField: 'category',
    legend: {
      color: {
        title: false,
        position: 'top',
        layout: {
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          flexDirection: 'column'
        }
        //rowPadding: 5,
      }
    },
    label: {
      // AT EACH Y POINT
      formatter: val => (val === 0 ? '' : val)
    }
  };

  return (
    <>
      <h2 className="text-uppercase">Detection Case Volume By Day</h2>

      <figure>
        {detectionCaseVol && detectionCaseVol.length > 0 ? (
          // <h1>Dumb</h1>
          <Line
            onReady={plot => {
              plot.chart.on('afterrender', args => {
                //window['chartRenders'][myId] = 'Done';
                window['chartRenders'] && delete window['chartRenders'][myId];
              });
            }}
            {...config}
          />
        ) : null}
        <figcaption>
          <Typography.Text type="secondary">
            Shows trending data for case activity by day.
          </Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
